<h2 mat-dialog-title>{{header}}</h2>
<mat-dialog-content #content>
  <p [innerHTML]="message | safeHtml"></p>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="okVisible || cancelVisible">
  <button mat-button [mat-dialog-close]="false" *ngIf="cancelVisible">Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial *ngIf="okVisible">OK</button>
</mat-dialog-actions>